module.exports = __webpack_public_path__ + "static/mildred-864a8aa62b12c2394a899124d224af55.svg";